<template>
    <multiselect
        v-model="headquartersSelected"
        :options="headquartersOptions"
        track-by="uuid"
        label="name"
        :multiple="true"
        :allowEmpty="false"
        placeholder="Seleccione"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapState, mapGetters} from 'vuex';

    export default {
        name: "HeadquartersMultipleSelector",
        components: {
            Multiselect
        },
        props: {
            value: Array,
            fromUser: Boolean
        },
        data: function () {
            return {
                headquartersSelected: [],
                headquartersOptions: []
            }
        },
        mounted() {
            this.$store.dispatch('loadHeadquarters');

            if (this.fromUser) {
                this.headquartersOptions = this.authUser().headquarters;
            }

            this.headquartersSelected = this.evaluateValue(this.value);
        },
        computed: {
            ...mapState([
                'headquarters',
            ])
        },
        methods: {
            ...mapGetters([
                'authUser',
            ]),
            evaluateValue(value) {
                if (Array.isArray(value) && !!value.length) {
                    let array = [];
                    value.forEach((headquarter) => {
                        if (
                            !!headquarter
                            && !!headquarter.uuid
                            && !!this.findHeadquartersByUuid(headquarter.uuid)
                        ) {
                            array.push(this.findHeadquartersByUuid(headquarter.uuid));
                        }
                    });
                    return array;
                } else {
                    return [];
                }
            },
            findHeadquartersByUuid(uuid) {
                if (this.headquarters) {
                    return this.headquartersOptions.find(headquarters => (headquarters.uuid === uuid));
                } else {
                    return null;
                }
            },
            notifyChange(headquarters) {
                this.$emit('input', headquarters);
            }
        },
        watch: {
            value: function () {
                this.headquartersSelected = this.evaluateValue(this.value);
            },
            headquartersOptions: function () {
                this.headquartersSelected = this.evaluateValue(this.value);
            },
            'headquarters.list': function (val) {
                if (!this.fromUser) {
                    this.headquartersOptions = val;
                }
            }
        }
    }
</script>

<style scoped>

</style>